import { useSearchParams, Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail, ArrowLeft } from "lucide-react";
import logoFull from "@/assets/logo-full.png";

export default function CheckEmail() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "your email";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-hero p-4">
      <Card className="w-full max-w-md shadow-elevated">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <img src={logoFull} alt="PTA Hub" className="h-12" />
          </div>
          <div className="flex justify-center mb-2">
            <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
              <Mail className="h-8 w-8 text-primary" />
            </div>
          </div>
          <CardTitle>Check Your Email</CardTitle>
          <CardDescription className="text-base">
            We've sent a verification link to
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-muted rounded-lg p-3 text-center">
            <p className="font-medium text-foreground break-all">{email}</p>
          </div>
          
          <div className="space-y-3 text-center text-sm text-muted-foreground">
            <p>
              Click the link in the email to verify your account. The link will expire in 24 hours.
            </p>
            <p>
              Once verified, you'll be able to log in and complete setting up your PTA.
            </p>
          </div>

          <div className="border-t pt-4 space-y-3">
            <p className="text-center text-sm text-muted-foreground">
              Didn't receive the email? Check your spam folder or contact{" "}
              <a href="mailto:info@ptahub.co.uk" className="text-primary hover:underline">
                info@ptahub.co.uk
              </a>
            </p>
            
            <Button asChild variant="outline" className="w-full">
              <Link to="/auth">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Sign In
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
